import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { environment, redirect } from '@env/environment';
// import { CookieService } from 'ngx-cookie-service';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import User from './User';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    // private redirectUrl = `${redirect.serasaConsumidorLogin}?redirectUrl=${redirect.basePath}`;

    // constructor(private http: HttpClient, private cookieService: CookieService) {}
    constructor() {}

    public saveUserData(userData: User) {
        localStorage.setItem('userData', JSON.stringify(userData));
    }

    public clearUserData() {
        sessionStorage.clear();
        localStorage.clear();
        // this.cookieService.set('Valgrind-AI', '', null, '/', location.host);
        // this.cookieService.deleteAll('/', location.host);
        // this.cookieService.deleteAll('/', '.serasa.com.br');
        // this.cookieService.deleteAll('/', 'www.serasa.com.br');
        // this.cookieService.deleteAll('/');
    }

    public getUserData(): User {
        const user = localStorage.getItem('userData');

        if (!user) {
            return new User({});
        }

        return new User(JSON.parse(user));
    }

    public logout() {
        this.clearUserData();

        // const bifrostToken = this.cookieService.get('Valgrind-AU');

    //     if (!bifrostToken) {
    //         return new Observable(observer => {
    //             observer.next();
    //             this.handleRedirect();
    //         });
    //     }

    //     const headers = new HttpHeaders({
    //         'Content-Type': 'application/json',
    //         'X-Bifrost-Authorization': bifrostToken
    //     });

    //     return this.http.get(environment.logoutUrl, { headers }).pipe(
    //         map(res => {
    //             this.handleRedirect();
    //             return res;
    //         }),
    //         catchError(error => {
    //             this.handleRedirect();
    //             throw error;
    //         })
    //     );
    }

    // private handleRedirect() {
    //     if (environment.logoutUrl) {
    //         setTimeout(() => {
    //             window.location.href = this.redirectUrl;
    //         }, 500);
    //     }
    // }
}
